// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jsonviewer {
    border-style: solid;
    border-color: gray; 
    border-width: thin;
}

.segment-key {
    color : white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/systemdatabase/systempassthrough.settings.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".jsonviewer {\n    border-style: solid;\n    border-color: gray; \n    border-width: thin;\n}\n\n.segment-key {\n    color : white !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
